import { Record, Union } from "../../fable_modules/fable-library-js.4.19.3/Types.js";
import { string_type, bool_type, option_type, record_type, array_type, class_type, union_type } from "../../fable_modules/fable-library-js.4.19.3/Reflection.js";
import { empty, filter, singleton, append as append_1, map, ofArray } from "../../fable_modules/fable-library-js.4.19.3/List.js";
import { substring, toFail } from "../../fable_modules/fable-library-js.4.19.3/String.js";
import { singleton as singleton_1, append, delay, toList } from "../../fable_modules/fable-library-js.4.19.3/Seq.js";
import { Visualization_UnifiedBranch, Visualization_UnifiedDistanceBranch, Visualization_UnifiedBranch_$reflection } from "../../RAWMap.Models/Common.js";
import { DisplayMap, Bounds_$reflection } from "./CommonBindings.js";

export class MeshViewportLocation extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["TopRight", "BottomLeft", "BottomRight"];
    }
}

export function MeshViewportLocation_$reflection() {
    return union_type("Client.Visualization.Common.Types.MeshViewportLocation", [], MeshViewportLocation, () => [[], [], []]);
}

export function MeshViewportLocation_get_all() {
    return ofArray([new MeshViewportLocation(0, []), new MeshViewportLocation(1, []), new MeshViewportLocation(2, [])]);
}

export function MeshViewportLocation_parse_Z721C83C5(s) {
    switch (s) {
        case "TopRight":
            return new MeshViewportLocation(0, []);
        case "BottomLeft":
            return new MeshViewportLocation(1, []);
        case "BottomRight":
            return new MeshViewportLocation(2, []);
        default:
            return toFail(`Unable to parse ${s}`);
    }
}

export function MeshViewportLocation_get_ofOrder() {
    return (_arg) => ((_arg === 0) ? (new MeshViewportLocation(0, [])) : ((_arg === 1) ? (new MeshViewportLocation(1, [])) : (new MeshViewportLocation(2, []))));
}

export class StentPlanningViewportIdentifier extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["StentPlanning", "Measurement", "DicomMain", "Axial", "Coronal", "Sagittal", "StretchedCpr", "StraightenedCpr", "CenterlineDicomPlaneA", "CenterlineDicomPlaneB"];
    }
}

export function StentPlanningViewportIdentifier_$reflection() {
    return union_type("Client.Visualization.Common.Types.StentPlanningViewportIdentifier", [], StentPlanningViewportIdentifier, () => [[], [], [], [], [], [], [], [], [], []]);
}

export function StentPlanningViewportIdentifier_get_meshViewports() {
    return ofArray([new StentPlanningViewportIdentifier(0, []), new StentPlanningViewportIdentifier(1, [])]);
}

export function StentPlanningViewportIdentifier_parseMeshViewport_Z721C83C5(s) {
    switch (s) {
        case "StentPlanning":
            return new StentPlanningViewportIdentifier(0, []);
        case "Measurement":
            return new StentPlanningViewportIdentifier(1, []);
        default:
            return toFail(`Unable to parse ${s}`);
    }
}

export const meshViewportNameOffset = 1 + "MeshViewportLocation".length;

export const stentPlanningNameOffset = 1 + "StentPlanningViewportIdentifier".length;

export class ViewportLocation extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["MeshViewportLocation", "StentPlanningViewportIdentifier"];
    }
}

export function ViewportLocation_$reflection() {
    return union_type("Client.Visualization.Common.Types.ViewportLocation", [], ViewportLocation, () => [[["Item", MeshViewportLocation_$reflection()]], [["Item", StentPlanningViewportIdentifier_$reflection()]]]);
}

export function ViewportLocation_get_all() {
    return toList(delay(() => append(map((Item) => (new ViewportLocation(0, [Item])), MeshViewportLocation_get_all()), delay(() => map((Item_1) => (new ViewportLocation(1, [Item_1])), StentPlanningViewportIdentifier_get_meshViewports())))));
}

export function ViewportLocation_parse_Z721C83C5(s) {
    if (s.indexOf("MeshViewportLocation") === 0) {
        return new ViewportLocation(0, [MeshViewportLocation_parse_Z721C83C5(substring(s, meshViewportNameOffset))]);
    }
    else if (s.indexOf("StentPlanningViewportIdentifier") === 0) {
        return new ViewportLocation(1, [StentPlanningViewportIdentifier_parseMeshViewport_Z721C83C5(substring(s, stentPlanningNameOffset))]);
    }
    else {
        return toFail(`Unable to parse ${s}`);
    }
}

export class TargetStudy extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["Current", "Previous"];
    }
}

export function TargetStudy_$reflection() {
    return union_type("Client.Visualization.Common.Types.TargetStudy", [], TargetStudy, () => [[], []]);
}

export class CardMode extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["Enabled", "ViewOnly", "Disabled"];
    }
}

export function CardMode_$reflection() {
    return union_type("Client.Visualization.Common.Types.CardMode", [], CardMode, () => [[], [], []]);
}

export class ActiveSegmentation extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["Lumen", "Wall", "Visceral"];
    }
}

export function ActiveSegmentation_$reflection() {
    return union_type("Client.Visualization.Common.Types.ActiveSegmentation", [], ActiveSegmentation, () => [[], [], []]);
}

export function ActiveSegmentation_get_all() {
    return ofArray([new ActiveSegmentation(0, []), new ActiveSegmentation(1, []), new ActiveSegmentation(2, [])]);
}

export function ActiveSegmentation_parse_Z721C83C5(s) {
    switch (s) {
        case "Lumen":
            return new ActiveSegmentation(0, []);
        case "Wall":
            return new ActiveSegmentation(1, []);
        case "Visceral":
            return new ActiveSegmentation(2, []);
        default:
            return toFail(`Unable to parse ${s}`);
    }
}

export function ActiveSegmentation_get_describe() {
    return (_arg) => ((_arg.tag === 1) ? "Wall" : ((_arg.tag === 2) ? "Visceral" : "Lumen"));
}

export function ActiveSegmentation_get_ofCenterlineType() {
    return (_arg) => ((_arg.tag === 1) ? (new ActiveSegmentation(1, [])) : (new ActiveSegmentation(0, [])));
}

export function ActiveSegmentation_tryParse_Z721C83C5(s) {
    switch (s) {
        case "Lumen":
            return new ActiveSegmentation(0, []);
        case "Wall":
            return new ActiveSegmentation(1, []);
        default:
            return undefined;
    }
}

export class LoadingStatus extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["Standby", "Downloading", "Extracting", "Rendering", "Complete"];
    }
}

export function LoadingStatus_$reflection() {
    return union_type("Client.Visualization.Common.Types.LoadingStatus", [], LoadingStatus, () => [[], [], [], [], []]);
}

export class DicomViewMode extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["Axial", "Coronal", "Sagittal", "StretchedCpr", "StraightenedCpr", "CenterlinePlaneA", "CenterlinePlaneB"];
    }
}

export function DicomViewMode_$reflection() {
    return union_type("Client.Visualization.Common.Types.DicomViewMode", [], DicomViewMode, () => [[], [], [], [["Item", Visualization_UnifiedBranch_$reflection()]], [["Item", Visualization_UnifiedBranch_$reflection()]], [["Item", Visualization_UnifiedBranch_$reflection()]], [["Item", Visualization_UnifiedBranch_$reflection()]]]);
}

export function DicomViewMode_get_describe() {
    return (_arg) => ((_arg.tag === 1) ? "Coronal" : ((_arg.tag === 2) ? "Sagittal" : ((_arg.tag === 3) ? "Stretched CPR" : ((_arg.tag === 4) ? "Straightened CPR" : ((_arg.tag === 5) ? "Centerline Plane A" : ((_arg.tag === 6) ? "Centerline Plane B" : "Axial"))))));
}

export function DicomViewMode_get_names() {
    const Axial = DicomViewMode_get_describe()(new DicomViewMode(0, []));
    const Coronal = DicomViewMode_get_describe()(new DicomViewMode(1, []));
    const Sagittal = DicomViewMode_get_describe()(new DicomViewMode(2, []));
    const StretchedCpr = DicomViewMode_get_describe()(new DicomViewMode(3, [new Visualization_UnifiedBranch(0, [new Visualization_UnifiedDistanceBranch(2, [])])]));
    const StraightenedCpr = DicomViewMode_get_describe()(new DicomViewMode(4, [new Visualization_UnifiedBranch(0, [new Visualization_UnifiedDistanceBranch(2, [])])]));
    return {
        Axial: Axial,
        CenterlinePlaneA: DicomViewMode_get_describe()(new DicomViewMode(5, [new Visualization_UnifiedBranch(0, [new Visualization_UnifiedDistanceBranch(2, [])])])),
        CenterlinePlaneB: DicomViewMode_get_describe()(new DicomViewMode(6, [new Visualization_UnifiedBranch(0, [new Visualization_UnifiedDistanceBranch(2, [])])])),
        Coronal: Coronal,
        Sagittal: Sagittal,
        StraightenedCpr: StraightenedCpr,
        StretchedCpr: StretchedCpr,
    };
}

export function DicomViewMode_get_isCenterline() {
    return (_arg) => ((_arg.tag === 5) ? true : (_arg.tag === 6));
}

export class ImageData extends Record {
    constructor(StandardImageFiles, CenterlineImageFiles, LumenMasks, WallMasks, VisceralMasks, CenterlineLumenMasks, CenterlineWallMasks) {
        super();
        this.StandardImageFiles = StandardImageFiles;
        this.CenterlineImageFiles = CenterlineImageFiles;
        this.LumenMasks = LumenMasks;
        this.WallMasks = WallMasks;
        this.VisceralMasks = VisceralMasks;
        this.CenterlineLumenMasks = CenterlineLumenMasks;
        this.CenterlineWallMasks = CenterlineWallMasks;
    }
}

export function ImageData_$reflection() {
    return record_type("Client.Visualization.Common.Types.ImageData", [], ImageData, () => [["StandardImageFiles", array_type(class_type("Browser.Types.File", undefined))], ["CenterlineImageFiles", array_type(class_type("Browser.Types.File", undefined))], ["LumenMasks", array_type(class_type("Browser.Types.File", undefined))], ["WallMasks", array_type(class_type("Browser.Types.File", undefined))], ["VisceralMasks", array_type(class_type("Browser.Types.File", undefined))], ["CenterlineLumenMasks", array_type(class_type("Browser.Types.File", undefined))], ["CenterlineWallMasks", array_type(class_type("Browser.Types.File", undefined))]]);
}

export function ImageData_StandardImageFiles__43A3F7B7(m) {
    return m.StandardImageFiles;
}

export function ImageData_CenterlineImageFiles__43A3F7B7(m) {
    return m.CenterlineImageFiles;
}

export function ImageData_LumenMasks__43A3F7B7(m) {
    return m.LumenMasks;
}

export function ImageData_WallMasks__43A3F7B7(m) {
    return m.WallMasks;
}

export function ImageData_VisceralMasks__43A3F7B7(m) {
    return m.VisceralMasks;
}

export function ImageData_CenterlineLumenMasks__43A3F7B7(m) {
    return m.CenterlineLumenMasks;
}

export function ImageData_CenterlineWallMasks__43A3F7B7(m) {
    return m.CenterlineWallMasks;
}

export class Meshes extends Record {
    constructor(CurrentStudy, PreviousStudy) {
        super();
        this.CurrentStudy = CurrentStudy;
        this.PreviousStudy = PreviousStudy;
    }
}

export function Meshes_$reflection() {
    return record_type("Client.Visualization.Common.Types.Meshes", [], Meshes, () => [["CurrentStudy", class_type("Client.Visualization.Common.Bindings.Meshes.IMeshes")], ["PreviousStudy", option_type(class_type("Client.Visualization.Common.Bindings.Meshes.IMeshes"))]]);
}

export function Meshes_Current_3B5CE845(m) {
    return m.CurrentStudy;
}

export function Meshes_Previous_3B5CE845(m) {
    return m.PreviousStudy;
}

export class VisualizationType extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["Mesh", "Dicom"];
    }
}

export function VisualizationType_$reflection() {
    return union_type("Client.Visualization.Common.Types.VisualizationType", [], VisualizationType, () => [[["Item", MeshViewportLocation_$reflection()]], []]);
}

export class InteractionMsg extends Union {
    constructor(Item) {
        super();
        this.tag = 0;
        this.fields = [Item];
    }
    cases() {
        return ["ViewportResized"];
    }
}

export function InteractionMsg_$reflection() {
    return union_type("Client.Visualization.Common.Types.InteractionMsg", [], InteractionMsg, () => [[["Item", Bounds_$reflection()]]]);
}

export const DisplayMap_all = ofArray([new DisplayMap(0, []), new DisplayMap(1, []), new DisplayMap(2, []), new DisplayMap(3, []), new DisplayMap(4, []), new DisplayMap(5, []), new DisplayMap(6, [])]);

export function DisplayMap_describe(_arg) {
    switch (_arg.tag) {
        case 1:
            return "Local Expansion Growth";
        case 2:
            return "Diametric Growth";
        case 3:
            return "ILT";
        case 4:
            return "RAW";
        case 5:
            return "Strain";
        case 6:
            return "VIGR";
        default:
            return "Anatomy";
    }
}

export const DisplayMap_nativeAortaMapsV1_5 = ofArray([new DisplayMap(0, []), new DisplayMap(5, []), new DisplayMap(3, [])]);

export const DisplayMap_nativeAortaMapsV1_6 = ofArray([new DisplayMap(0, []), new DisplayMap(5, []), new DisplayMap(4, []), new DisplayMap(3, [])]);

export const DisplayMap_nativeAortaMapsV1_6Research = append_1(DisplayMap_nativeAortaMapsV1_6, singleton(new DisplayMap(6, [])));

export const DisplayMap_evarMaps = ofArray([new DisplayMap(0, []), new DisplayMap(5, [])]);

export function DisplayMap_withGrowthMapsV1_5(maps) {
    return toList(delay(() => append(maps, delay(() => singleton_1(new DisplayMap(2, []))))));
}

export function DisplayMap_withGrowthMapsV1_6(maps) {
    return toList(delay(() => append(maps, delay(() => append(singleton_1(new DisplayMap(2, [])), delay(() => singleton_1(new DisplayMap(1, []))))))));
}

export const DisplayMap_clinicalMaps = singleton(new DisplayMap(0, []));

export class MapDataAvailability extends Record {
    constructor(hasStrain, hasIlt, hasContinuousRaw, hasVigr, rawContinuousArrayName) {
        super();
        this.hasStrain = hasStrain;
        this.hasIlt = hasIlt;
        this.hasContinuousRaw = hasContinuousRaw;
        this.hasVigr = hasVigr;
        this.rawContinuousArrayName = rawContinuousArrayName;
    }
}

export function MapDataAvailability_$reflection() {
    return record_type("Client.Visualization.Common.Types.MapDataAvailability", [], MapDataAvailability, () => [["hasStrain", bool_type], ["hasIlt", bool_type], ["hasContinuousRaw", bool_type], ["hasVigr", bool_type], ["rawContinuousArrayName", string_type]]);
}

export function MapDataAvailability_get_allAvailable() {
    return new MapDataAvailability(true, true, true, true, "");
}

export function MapDataAvailability_intersect(current, previous) {
    return new MapDataAvailability(current.hasStrain && previous.hasStrain, current.hasIlt && previous.hasIlt, (current.hasContinuousRaw && previous.hasContinuousRaw) && (current.rawContinuousArrayName === previous.rawContinuousArrayName), current.hasVigr && previous.hasVigr, current.rawContinuousArrayName);
}

export function getAvailableMaps(isFollowup, hasDiametricGrowth, analysisPipelineVersion, institutionDesignation, availability, svm) {
    let matchValue, matchValue_1;
    return filter((_arg) => {
        switch (_arg.tag) {
            case 5:
                return availability.hasStrain;
            case 3:
                return availability.hasIlt;
            case 4:
                return availability.hasContinuousRaw;
            case 6:
                return availability.hasVigr;
            default:
                return true;
        }
    }, (matchValue = svm.isPostTreatment, (matchValue_1 = svm.postTreatTreatmentType, (institutionDesignation.tag === 1) ? DisplayMap_clinicalMaps : (isFollowup ? ((analysisPipelineVersion === 1.5) ? (hasDiametricGrowth ? ((matchValue == null) ? DisplayMap_withGrowthMapsV1_5(DisplayMap_nativeAortaMapsV1_5) : ((matchValue.tag === 1) ? DisplayMap_withGrowthMapsV1_5(DisplayMap_nativeAortaMapsV1_5) : ((matchValue_1 == null) ? empty() : ((matchValue_1.tag === 0) ? empty() : DisplayMap_withGrowthMapsV1_5(DisplayMap_evarMaps))))) : ((matchValue == null) ? DisplayMap_nativeAortaMapsV1_5 : ((matchValue.tag === 1) ? DisplayMap_nativeAortaMapsV1_5 : ((matchValue_1 == null) ? empty() : ((matchValue_1.tag === 0) ? empty() : DisplayMap_evarMaps))))) : (hasDiametricGrowth ? ((matchValue == null) ? DisplayMap_withGrowthMapsV1_6(DisplayMap_nativeAortaMapsV1_6Research) : ((matchValue.tag === 1) ? DisplayMap_withGrowthMapsV1_6(DisplayMap_nativeAortaMapsV1_6Research) : ((matchValue_1 == null) ? empty() : ((matchValue_1.tag === 0) ? empty() : DisplayMap_withGrowthMapsV1_6(DisplayMap_evarMaps))))) : ((matchValue == null) ? DisplayMap_nativeAortaMapsV1_6Research : ((matchValue.tag === 1) ? DisplayMap_nativeAortaMapsV1_6Research : ((matchValue_1 == null) ? empty() : ((matchValue_1.tag === 0) ? empty() : DisplayMap_evarMaps)))))) : ((matchValue == null) ? ((analysisPipelineVersion === 1.5) ? DisplayMap_nativeAortaMapsV1_5 : DisplayMap_nativeAortaMapsV1_6Research) : ((matchValue.tag === 1) ? ((analysisPipelineVersion === 1.5) ? DisplayMap_nativeAortaMapsV1_5 : DisplayMap_nativeAortaMapsV1_6Research) : ((matchValue_1 == null) ? empty() : ((matchValue_1.tag === 0) ? empty() : DisplayMap_evarMaps))))))));
}

